import React, { useCallback } from 'react';

const StaticDoc = ({ type }) => {
  const src = type === 'privacy' ? '/Privacy.html' : '/Terms.html';
  const onLoad = useCallback((e) => {
    try {
      const iframe = e.currentTarget;
      const doc = iframe.contentDocument || iframe.contentWindow?.document;
      if (!doc) return;
      const style = doc.createElement('style');
      style.textContent = `
        .header, footer.footer { display: none !important; }
        body { background: transparent !important; }
        main { 
          max-width: 1000px !important; 
          margin: 0 auto !important; 
          box-shadow: none !important; 
          border: none !important;
        }
      `;
      doc.head && doc.head.appendChild(style);
    } catch (_) {}
  }, []);
  return (
    <div style={{ width: '100%', margin: '0 auto', padding: '12px 0 24px' }}>
      <iframe
        title={type === 'privacy' ? 'Privacy Policy' : 'Terms & Conditions'}
        src={src}
        onLoad={onLoad}
        style={{ width: '100%', minHeight: '80vh', border: 'none' }}
      />
    </div>
  );
};

export default StaticDoc;


